import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SplashScreen } from '@capacitor/splash-screen';
import { NavController } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { EventsService } from 'src/app/providers/events/events.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { Capacitor } from "@capacitor/core";

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  logo_on: boolean;
  loginForm: FormGroup;
  forgotForm: FormGroup;
  showform: boolean;
  loginscreen: boolean;
  constructor(
    public storageService: StorageService,
    private eventsService: EventsService,
    public formBuilder: FormBuilder,
    private apiService: ApiService,
    private toastService: ToastService,
    public router: Router,
    public navCtrl: NavController,
    public events: EventsService,

  ) {
    //console.log('at login?');
    this.loginscreen = true;
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.forgotForm = this.formBuilder.group({
      email: ['', [Validators.required]],
    });
  }

  ngOnInit() { 
    SplashScreen.hide();
    this.logo_on = true;
  }

  hidelogo()
  {
    this.logo_on=false;
  }
  showlogo()
  {
    this.logo_on=true;
  }

  //login function
  onSubmit(type) {
    if (type) {
      if (!this.loginForm.valid) {
        this.toastService.presentToastError('Please provide a username and password!');
        return false;
      } else {
        const params = {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          User: this.loginForm.value,
        };
        this.toastService.presentLoading();
        this.apiService.login('login-user', params).subscribe(
          (res) => {
            this.toastService.dismissLoading();

            if (res.error === false) {
              this.storageService.setObject('userInfo', this.loginForm.value);
              this.storageService.setObject('mbeUser', res.userInfo);
              this.storageService.setObject('userLockTimeout', res.lockTimeout);
              // if (res.userInfo.pin) {
              //   this.storageService.set('pin', res.userInfo.pin);
              // }
              this.events.publish('user:active', this.loginForm.value);
              this.eventsService.setDoctorRole(res.userInfo.anaesthetics, res.userInfo.icu, res.userInfo.physician, res.userInfo.surgeon);
              this.updateuserlogin();
              this.navCtrl.navigateRoot('/lock');
            } else {
              this.toastService.presentToastError(res.error.uiMessage);
            }
          },
          (err) => {
            this.toastService.dismissLoading();
          }
        );
      }
    } else {
      //console.log('forgot password');
      if (!this.forgotForm.valid) {
        this.toastService.presentToastError('Please enter an email address!');
        return false;
      } else {
        this.apiService.post('forgot-password', this.forgotForm.value).subscribe(
          (res) => {
            if (res.error === false) {
              this.toastService.presentToast('success', res.message);
              this.navCtrl.navigateForward('/login');
            } else {
              this.toastService.presentToastError(res.message);
            }
          },
          (err) => { }
        );
      }
    }
  }

  updateuserlogin() {

    const params = {
      platform: Capacitor.getPlatform()
    };
    //console.log(this.userPlatform);
    this.apiService.post('updatelastlogin',params).subscribe(
      (res) => {
        if (res.error === false) {
        }
      },
      (err) => {
        //console.log(err);
      }
    );
  }

  doLogin()
  {
    if (!this.loginForm.valid) {
      this.toastService.presentToastError('Please provide a username and password!');
      return false;
    } else {
      const params = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        User: this.loginForm.value,
      };
      this.toastService.presentLoading();
      this.apiService.login('login-user', params).subscribe(
        (res) => {
          this.toastService.dismissLoading();

          if (res.error === false) {
            this.storageService.setObject('userInfo', this.loginForm.value);
            this.storageService.setObject('mbeUser', res.userInfo);
            // if (res.userInfo.pin) {
            //   this.storageService.set('pin', res.userInfo.pin);
            // }
            this.events.publish('user:active', this.loginForm.value);
            this.eventsService.setDoctorRole(res.userInfo.anaesthetics, res.userInfo.icu, res.userInfo.physician, res.userInfo.surgeon);
            this.updateuserlogin();
            this.navCtrl.navigateRoot('/lock');
          } else {
            this.toastService.presentToastError(res.error.uiMessage);
          }
        },
        (err) => {
          this.toastService.dismissLoading();
        }
      );
      this.apiService.login('getUserSettings',params).subscribe (
        (res) => {
          this.toastService.dismissLoading();

          if (res.error === false) {
            //console.log('usersettings: ',res);
            this.storageService.setObject('userLockTimeout', res.lockTimeout);
          }
          else {

          }
        }
      );
  }
}
  doReset()
  {
    //console.log('forgot password');
    if (!this.forgotForm.valid) {
      this.toastService.presentToastError('Please enter an email address!');
      return false;
    } else {
      this.apiService.post('forgot-password', this.forgotForm.value).subscribe(
        (res) => {
          if (res.error === false) {
            this.toastService.presentToast('success', res.message);
            this.loginscreen = true;
            this.navCtrl.navigateForward('/login');
          } else {
            this.toastService.presentToastError(res.message);
          }
        },
        (err) => { }
      );
    }
  }

  lock() {
    //console.log('going to lock?');
    this.navCtrl.navigateForward('/lock');
  }
  
  _goToTutorial() {
    //console.log('going to tutorial!');
    this.router.navigate(['../tutorial']);
  }
}
